import script from "./Sobre.vue?vue&type=script&setup=true&lang=js"
export * from "./Sobre.vue?vue&type=script&setup=true&lang=js"

import "./Sobre.vue?vue&type=style&index=0&id=0913330e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0913330e"]])

export default __exports__